<template>
    <v-card class="metric-card d-flex align-center pa-6" elevation="0">
        <!-- Icon Section -->
        <div class="icon-wrapper mr-5">
            <!-- Mint Background Circle -->
            <div class="icon-circle">
                <v-icon color="#00C48C" size="32">{{ icon }}</v-icon>
            </div>
            <!-- Red Badge Overlay -->
            <div class="icon-badge" v-if="badgeIcon">
                <v-icon x-small color="white" size="12">{{ badgeIcon }}</v-icon>
            </div>
        </div>

        <!-- Content Section -->
        <div class="flex-grow-1">
            <div class="metric-value mb-0">{{ value }}</div>
            <div class="metric-title grey--text text--lighten-1 mb-1">{{ title }}</div>

            <div class="d-flex align-center mt-1">
                <div class="trend-dot mr-2" :style="{ backgroundColor: trendColor }"></div>
                <span class="metric-subtitle" :style="{ color: trendColor }">
                    {{ subtitle }}
                </span>
            </div>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "SellerMetricCard",
    props: {
        title: { type: String, default: "" },
        value: { type: [String, Number], default: "" },
        subtitle: { type: String, default: "" },
        icon: { type: String, default: "" },
        badgeIcon: { type: String, default: "" },
        trendUp: { type: Boolean, default: true }
    },
    computed: {
        trendColor() {
            // If trendUp is true -> Green (#00C48C)
            // If trendUp is false -> Red (#FF5B5B)
            return this.trendUp ? '#00C48C' : '#FF5B5B';
        }
    }
};
</script>

<style scoped>
.metric-card {
    border-radius: 20px;
    background-color: #FFFFFF;
    box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.03) !important;
    height: 100%;
    transition: transform 0.2s, box-shadow 0.2s;
}

.metric-card:hover {
    transform: translateY(-4px);
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.06) !important;
}

.icon-wrapper {
    position: relative;
    width: 72px;
    height: 72px;
}

.icon-circle {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #E0F9F1;
    /* Mint Green for all cards as per design */
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-badge {
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #FF5B5B;
    /* Red Badge */
    border: 4px solid #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.metric-value {
    font-size: 32px;
    font-weight: 800;
    color: #2D3748;
    line-height: 1.2;
}

.metric-title {
    font-size: 13px;
    font-weight: 500;
}

.trend-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 1), 0 0 0 3px currentColor;
    opacity: 0.8;
}

.metric-subtitle {
    font-size: 11px;
    font-weight: 600;
}
</style>
